<template>
  <div>
    <dv-scroll-board
      :config="config"
      style="width: 100%; height: 220px; color: #b9b9b9"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {
        rowNum: 6,
        columnWidth: [175, 280],
        oddRowBGC: 'rgba(0,0,0,0)',
        evenRowBGC: 'rgba(168,229,189,.1)',
        waitTime: 3500,
        data: [
          ['WGH-17-18180', '合肥鑫土地农业科技有限公司', '无公害'],
          ['WGH-17-18346', '长丰县下塘镇邵君山家庭农场', '无公害'],
          ['WGH-17-17378', '长丰县岗集镇丰泰蔬果农场', '无公害'],
          ['WGH-17-06655', '长丰利鑫家庭农场', '无公害'],
          ['WGH-17-03247', '长丰县吴山镇永丰家庭农场', '无公害'],
          ['WGH-17-18373', '合肥安谷农业有限公司', '无公害'],
          ['WGH-17-03703', '长丰县陶楼镇新丰水果专业合作社', '无公害'],
          ['WGH-17-03578', '长丰县陶楼镇新丰水果专业合作社', '无公害'],
          ['LB-15-18031201991A', '合肥市金锁家庭农场有限公司', '绿色'],
          ['LB-15-18011200140A', '长丰县陶楼镇光勤蔬菜种植家庭农场', '绿色'],
          ['LB-15-1707124209A', '合肥青峰岭有机富硒果蔬专业合作社', '绿色'],
          ['LB-15-1707124210A', '合肥青峰岭有机富硒果蔬专业合作社', '绿色'],
          ['LB-15-1707124211A', '合肥青峰岭有机富硒果蔬专业合作社', '绿色'],
          ['LB-15-1611126289A', '长丰县双墩镇三口塘家庭农场', '绿色'],
          ['LB-15-20081210759A', '合肥畅天农业科技有限公司', '绿色'],
          ['LB-15-18031202593', '合肥市艳九天农业科技有限公司', '绿色'],
          ['LB-15-1703121565A', '长丰县造甲乡锐丰家庭农场', '绿色'],
          ['LB-15-19051207517A', '安徽凤麟农业科技有限公司', '绿色'],
        ],
      },
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/administration-zone/certification-scroller.vue